<div class="review-detail">
  <div class="page-header">
    <div class="header-top">
      <button mat-button class="btn-orange back-button" (click)="goBack()">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        Volver
      </button>
      <h1 class="title">Detalle de liquidación</h1>
    </div>
    <p class="subtitle">Cliente: {{ partnerName || partnerId }}</p>
  </div>

  <div *ngIf="!detail" class="text-white">Cargando detalle...</div>

  <div *ngIf="detail" class="detail-grid">
    <mat-card class="summary-card">
      <div class="summary-row">
        <div>
          <p class="label">Semana</p>
          <p class="value">{{ detail.week }}</p>
        </div>
        <div>
          <p class="label">Año</p>
          <p class="value">{{ detail.year }}</p>
        </div>
        <div>
          <p class="label">Mes</p>
          <p class="value">{{ detail.month }}</p>
        </div>
        <div>
          <p class="label">Días aplicados</p>
          <p class="value">{{ detail.daysToApply }}</p>
        </div>
        <div *ngIf="isWeekly">
          <p class="label">Rango de fechas</p>
          <p class="value">{{ formatDateDisplay(detail.startDate) }} - {{ formatDateDisplay(detail.endDate) }}</p>
        </div>
      </div>
      <div class="summary-row">
        <div>
          <p class="label">ISR</p>
          <p class="value">{{ detail.paysISR ? 'Aplica' : 'No aplica' }}</p>
        </div>
        <div>
          <p class="label">Estado</p>
          <p class="value">{{ getTranslatedStatus(detail.status) }}</p>
        </div>
        <div *ngIf="detail.rejectionReason">
          <p class="label text-red-400">Motivo rechazo</p>
          <p class="value text-red-300">{{ detail.rejectionReason }}</p>
        </div>
      </div>
    </mat-card>

    <mat-card class="sections-card">
      <h2>Resumen de liquidación</h2>
      <div *ngFor="let group of invoiceRowsByEntity" class="summary-table entity-section">
        <h3 class="entity-title">{{ group.entityName }}</h3>
        <table>
          <thead>
            <tr>
              <th>Grupo</th>
              <th *ngIf="isDaily">Fecha</th>
              <th>Descuentos</th>
              <th>Total a facturar</th>
              <th>Depósito para liberar planilla</th>
              <th>Total a recibir</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of group.rows">
              <td>{{ getRowGroupLabel(item.row) }}</td>
              <td *ngIf="isDaily">{{ formatDateDisplay(item.row.date) }}</td>
              <td>
                <div class="discount-list">
                  <div *ngFor="let d of item.row.discounts">{{ d.name }}: Q {{ d.amount | number:'1.2-2' }}</div>
                  <div *ngIf="item.row.isrAmount > 0">ISR: Q {{ item.row.isrAmount | number:'1.2-2' }}</div>
                  <div *ngIf="item.row.retentionIVAAmount > 0">RETENCIÓN IVA: Q {{ item.row.retentionIVAAmount | number:'1.2-2' }}</div>
                </div>
              </td>
              <td>Q {{ item.totalToInvoice | number:'1.2-2' }}</td>
              <td>Q {{ (item.netAmount < 0 ? (item.netAmount * -1) : 0) | number:'1.2-2' }}</td>
              <td>Q {{ (item.netAmount > 0 ? item.netAmount : 0) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card>

    <div class="flex flex-col gap-4 uploads-grid">
      <mat-card class="upload-card">
        <div class="card-header">
          <div>
            <h2>Facturas</h2>
            <p class="helper">Documentos en PDF.</p>
          </div>
        </div>
        <div *ngIf="invoiceRowsToBillByEntity.length; else noInvoices">
          <div *ngFor="let group of invoiceRowsToBillByEntity" class="readonly-table entity-section">
            <h3 class="entity-title">{{ group.entityName }}</h3>
            <table>
              <thead>
                <tr>
                  <th>Grupo</th>
                  <th *ngIf="isDaily">Fecha</th>
                  <th>Archivo</th>
                  <th>Número</th>
                  <th>Fecha</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of group.rows">
                  <td>{{ getRowGroupLabel(item.row) }}</td>
                  <td *ngIf="isDaily">{{ formatDateDisplay(item.row.date) }}</td>
                  <td>
                    <a [href]="item.invoice.url" target="_blank" rel="noopener" class="file-link inline-link">
                      {{ item.invoice.fileName }}
                    </a>
                  </td>
                  <td>{{ item.invoice.number }}</td>
                  <td>{{ formatDateDisplay(item.invoice.date) }}</td>
                  <td>Q {{ item.totalToInvoice | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <ng-template #noInvoices>
          <div class="text-gray">No hay facturas cargadas.</div>
        </ng-template>
      </mat-card>

      <mat-card class="upload-card">
        <div class="card-header">
          <div>
            <h2>Depósitos</h2>
            <p class="helper">Comprobantes en PDF.</p>
          </div>
        </div>
        <div *ngIf="depositRowsToBillByEntity.length; else noDeposits">
          <div *ngFor="let group of depositRowsToBillByEntity" class="readonly-table entity-section">
            <h3 class="entity-title">{{ group.entityName }}</h3>
            <table>
              <thead>
                <tr>
                  <th>Grupo</th>
                  <th *ngIf="isDaily">Fecha</th>
                  <th>Archivo</th>
                  <th>Número</th>
                  <th>Fecha</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of group.rows">
                  <td>{{ getRowGroupLabel(item.row) }}</td>
                  <td *ngIf="isDaily">{{ formatDateDisplay(item.row.date) }}</td>
                  <td>
                    <a [href]="item.deposit.url" target="_blank" rel="noopener" class="file-link inline-link">
                      {{ item.deposit.fileName }}
                    </a>
                  </td>
                  <td>{{ item.deposit.number }}</td>
                  <td>{{ formatDateDisplay(item.deposit.date) }}</td>
                  <td>Q {{ item.deposit.amount | number:'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <ng-template #noDeposits>
          <div class="text-gray">No hay depósitos cargados.</div>
        </ng-template>
      </mat-card>
    </div>

    <mat-card *ngIf="canReview" class="review-card">
      <div class="actions-row">
        <mat-form-field appearance="outline" floatLabel="always" class="w-full border-0 mb-2">
          <mat-label class="text-gray text-lg">Motivo de rechazo</mat-label>
          <textarea matInput rows="3" [(ngModel)]="rejectionReason" placeholder="Completa solo si vas a rechazar" class="text-lg text-white bg-blue-primary"></textarea>
        </mat-form-field>
      </div>
      <div class="actions-row justify-end">
        <button mat-flat-button class="btn-orange" (click)="onApprove()" [disabled]="loading">
          <mat-icon fontIcon="check"></mat-icon>
          Aprobar
        </button>
        <button mat-flat-button class="btn-red" (click)="onReject()" [disabled]="loading">
          <mat-icon fontIcon="close"></mat-icon>
          Rechazar
        </button>
      </div>
    </mat-card>
  </div>
</div>
